export { default } from "./Text";
export { default as TextWithIcon } from "./TextWithIcon";
